// Port of api/fuel/app/classes/insights/game/worth.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'worth',
    priority: 1,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var game_id = parseInt(vars.id, 10)
        var collection = this._data.collection
        var version = this._data.version
        var totalPlays = this._data.totalPlays

        var worth = {
            current: null,
            history: [],
            versionWorth: null,
            costPerPlay: null
        }

        // Price history from insight_game_value
        var historyRaw = Util.queryFast(
            'SELECT v.insight_date AS date, v.insight_value AS value ' +
            'FROM insight_game_value v ' +
            'WHERE v.game_id = ' + game_id + ' AND v.insight_value > 0 ' +
            'ORDER BY v.insight_date ASC'
        )

        for (var i = 0; i < historyRaw.length; i++) {
            worth.history.push({
                d: parseInt(historyRaw[i].date, 10),
                v: parseFloat(historyRaw[i].value)
            })
        }

        // Current value is the most recent entry
        if (worth.history.length) {
            worth.current = worth.history[worth.history.length - 1].v
        }

        // Version worth
        if (version && version.get_worth_value()) {
            worth.versionWorth = parseFloat(version.get_worth_value())
        }

        // Cost per play
        var collectionValue = (collection && collection.get_value()) ? parseFloat(collection.get_value()) : null

        if (collectionValue && totalPlays > 0) {
            worth.costPerPlay = Math.round((collectionValue / totalPlays) * 100) / 100
        }

        return {
            worth: worth
        }

    }
})
